// Public-side mirror of <SoldOutOverlay>. Same trigger condition (every zone
// booked), calmer tone — no shouty "WE DID IT". Settled, branded summary
// card guests see on their phone.
//
// Public /live bundle constraint: no lucide-react / motion/react imports.
// CSS keyframe animations only.

interface Props {
  total: number;
  revenue: number;
  currency?: string;
}

export function LiveSoldOut({ total, revenue, currency = "£" }: Props): JSX.Element {
  return (
    <div className="absolute inset-0 z-20 grid place-items-center p-6 pointer-events-none">
      {/* Subtle accent radial backdrop only — the pitch fills underneath
          stay readable (and rightly so; sold-out IS the picture). */}
      <div
        className="absolute inset-0 animate-fade-up"
        style={{
          background:
            "radial-gradient(circle at center, rgb(var(--accent) / 0.16), rgb(var(--bg) / 0.6) 65%)",
        }}
        aria-hidden
      />
      <div className="relative text-center animate-fade-up">
        {/* Inline check-circle SVG — no Lucide in the public bundle. */}
        <div className="mx-auto w-14 h-14 rounded-full bg-accent/20 border border-accent/50 grid place-items-center mb-4">
          <svg viewBox="0 0 24 24" fill="none" className="w-7 h-7" aria-hidden>
            <path
              d="M5 13l4 4L19 7"
              stroke="rgb(var(--accent))"
              strokeWidth={2.6}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="text-xs uppercase tracking-[0.4em] text-accent mb-2">Sold out</div>
        <div className="font-display text-4xl md:text-5xl mb-4 leading-tight">
          Every square taken.
        </div>
        <div className="text-fg-muted tabular-nums">
          <span className="text-fg font-semibold">{total}</span> zones
          <span className="mx-2 opacity-40">·</span>
          <span className="text-fg font-semibold">
            {currency}
            {revenue.toLocaleString("en-GB")}
          </span>{" "}
          raised
        </div>
        <div className="text-xs text-fg-muted mt-4">Stay tuned for the draws.</div>
      </div>
    </div>
  );
}
